// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveLowerEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

export const itemFieldTypeSchema = caseInsensitiveLowerEnum([
  'text',
  'multiline_text',
  'number',
  'integer',
  'date',
  'time',
  'date_time',
  'boolean',
]);

export type ItemFieldType = z.infer<typeof itemFieldTypeSchema>;
